/*
* Public API surface of xpo-ui-core
* */
export * from './lib/notes-emails/index';
